import { Loader } from '@googlemaps/js-api-loader';

export const moduleMap = () =>{
	//Get all map objects on the page
	let jsMaps = [].slice.call(document.querySelectorAll('.js__map'));

	//Only init maps when they scroll into view
	if ("IntersectionObserver" in window) {
		var lazyMapObserver;
		lazyMapObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(map) {
				if (map.isIntersecting) {

					//Set Google API credentials
					let googleLoader = new Loader({
					  apiKey: "AIzaSyCC0nJSV1K42Cxhx4raqVXHiRWr9hfOSQk",
					  version: "weekly",
					  libraries: ["places"]
					});

					//Get map display coordiantes from element data attributes, otherwise default to London
					let mapLocation = { 
						lat: parseFloat(map.target.dataset.lat) || 51.5320501, 
						lng: parseFloat(map.target.dataset.lng) || -0.124512,
					};

					//Get API code from Google
					googleLoader
			  		.load()
			  		.then((google) => {

			  			//Configure Map
			  			let mapArgs = {
					    	zoom        : 16,
						    mapTypeId   : google.maps.MapTypeId.ROADMAP,
						    center 		: mapLocation,
						    zoomControl: true,
						    mapTypeControl: false,
						    scaleControl: false,
						    streetViewControl: true,
						    rotateControl: false,
						    fullscreenControl: false
						};

						//Init map object
				   		let mapObject = new google.maps.Map(map.target, mapArgs);

				   		//Add a marker to be super clear
				   		let mapMarker = new google.maps.Marker({
							position: mapLocation,
							map: mapObject,
						});
				  	})
				  	.catch((e) => {
				    	// do something
				  	});	
					
					//Remove this map from the observer, as it's now loaded in
					lazyMapObserver.unobserve(map.target);
				}
			});
		});

		if(lazyMapObserver){
			jsMaps.forEach(function(jsMap) {
				lazyMapObserver.observe(jsMap);
			});
		}
		
	}

}




